import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-headhunting',
  templateUrl: './headhunting.component.html',
  styleUrls: ['./headhunting.component.css']
})
export class HeadhuntingComponent implements OnInit {

  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  businessID = this.route.snapshot.params.businessID;
  openings = [];
  open_profiles = 0;

  constructor( 
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) { }

  ngOnInit(): void {
    this.fetchHeadHuntingProfiles();
  }

  fetchHeadHuntingProfiles() {
    this.http.get(environment.USER_HEADHUNTING_PROFILES, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.openings = res.message;

          for (let i = 0; i < this.openings.length; i++) {
            const profile = this.openings[i];

            if(profile.can_open){
              this.open_profiles += 1;
            }
            
          }
          console.log(this.openings)
        }
        else {
          this.openings = []
        }
        
      }, (err: any) => {

      }
    )
  }

  openProfile(data){
    var req = {
      userID: data.token,
      type: 'headhunting_profile_opening'
    }


    this.http.post(environment.OPENING_USER_PROFILE, req, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          alert('Profile opened')
        }
        else {
          console.log('buu')
        }
        
      }, (err: any) => {

      }
    )
  }

  routeProfile(data) {
    console.log(data,'/'+this.businessID + '/openings/profile-opened/headhunting' + data.token)
    this.router.navigate(['/'+this.businessID + '/openings/profile-opened/headhunting/no-opening/' + data.token])
  }

}
